import "./App.css";
import "./styles/ComponentsStyle.css";
import AuthGuard from "./components/Auth/AuthGuard";
import { useSelector } from "react-redux";
import { RootState } from "./redux/store";
import { AppRouter } from "./router/AppRouter";

function App() {
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth.isAuthenticated,
  );

  return (
    <div className="App">
      {isAuthenticated ? (
        <AuthGuard>
          <AppRouter />
        </AuthGuard>
      ) : (
        <AppRouter />
      )}
    </div>
  );
}

export default App;
